import UserDevices from "./UserDevices";

export default UserDevices;
